import React, { ChangeEvent, FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import { IFormField } from "src/@types/form";
import { FormField } from ".";
import { FileInput } from "../FileInput";

export const FileField: FC<IFormField> = ({
  className,
  fieldClassName,
  labelClassName,
  id,
  label,
  placeholder,
  accept,
  errorClassName,
  ...props
}) => {
  const { t } = useTranslation();

  const name = props.name as string;

  const fieldId = id || name;

  const [{ value }, { error, touched }, { setValue }] = useField(fieldId);

  const isShownError = Boolean((touched || value) && error);

  const placeholderText =
    typeof placeholder === "string"
      ? placeholder
      : placeholder && t(placeholder.i18nKey, placeholder.i18nParams);

  const combinedClassNames = cn("w-full", className);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0];
    setValue(file);
  };

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      label={label}
      labelFor={fieldId}
      isShownError={isShownError}
      error={error}
      errorClassName={errorClassName}
    >
      <FileInput
        id={fieldId}
        accept={accept}
        className={combinedClassNames}
        onChange={onChange}
        placeholder={placeholderText}
        isUploaded={Boolean(value && !isShownError)}
      />
    </FormField>
  );
};
